// extracted by mini-css-extract-plugin
export default {"header":"InfoPopup_header__5Bkr2","content":"InfoPopup_content__kxHqA"};